<template>
  <div id="pageMn">
    <Page :total="total" :current="current"
          :page-size="pageSize"
          @on-change="getPager">
    </Page>
    <p class="titlefont aqt_lang_mn pagetitle">{{ $t('m.goto')|U2M }}</p>
    <div class="input_page aqt_su">
      <textarea @keydown="getkeydown"  @blur="blurPage" v-model="inputPage"></textarea>
    </div>
    <p class="titlefont aqt_lang_mn pagetitle">{{ $t('m.p')|U2M }}</p>
  </div>
</template>


<script>
export default {
  props: {
    total: {
      type: [Number, String],
      default: 0
    },
    current: {
      type: [Number, String],
      default: 1
    },
    pageSize: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      inputPage: 1
    }
  },
  methods: {
    getPager(page) {
      this.$emit('getPager', page)
    },
    isNumber(str) {
      return !isNaN(str);
    },
    blurPage(e){
      if(!this.isNumber(e.target.value*1)){
        this.inputPage = 1
      }
      if (e.target.value * 1 <= 0) {
        this.inputPage = 1
      }
    },
    getkeydown(e) {
      if(!this.isNumber(e.target.value*1)){
        this.inputPage = 1
      }
      if (e.target.value * 1 <= 0) {
        this.inputPage = 1
      }
      if (e.keyCode == 13 && e.ctrlKey) {
        document.getElementById("a").value += "\n";
      } else if (e.keyCode == 13) {
        // 避免回车键换行
        e.preventDefault();
        // 下面写你的发送消息的代码
        this.getPager(this.inputPage)
      }
    }
  },
  created() {
    this.inputPage = this.current
  },
  watch: {
    current: function (newVal) {
      this.inputPage = newVal
    },
  }
}
</script>

<style lang="less">
#pageMn {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .pagetitle {
    width: 100%;
    margin: 13px 0;
    color: #888888;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .input_page {
    width: 30px;
    height: 50px;

    textarea {
      width: 100%;
      height: 100%;
      font-size: 16px;
      display: table-column !important;
      color: #888888;
      text-indent: 1rem;
      resize: none;
      border: none;
      outline: none;
      overflow-x: hidden !important;
      white-space: nowrap;
      line-height: 30px;
      font-weight: unset;
      font-weight: normal;
      font-family: "MGQ8102" !important;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      background: #ffffff;
    }

    textarea::-webkit-input-placeholder { /* WebKit browsers */
      line-height: 40px !important;
    }

    textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: #888888;
    }

    textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #888888;
    }

    textarea:-ms-input-placeholder { /* Internet Explorer 10+ */
      color: #888888;
    }
  }

  ul {
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;

    li {
      writing-mode: vertical-lr;
      text-orientation: sideways-right;
      text-orientation: sideways !important;
      -o-text-orientation: sideways !important;
      -ms-text-orientation: sideways !important;
      -moz-text-orientation: sideways !important;
      -webkit-text-orientation: sideways !important;
      -webkit-text-orientation: sideways-right !important;
      margin-right: 0 !important;
      margin-bottom: 4px !important;
      height: 43px !important;
    }

    .ivu-page-item-active {
      background: var(--themeColor) !important;
      border: 0px solid var(--themeColor) !important;
    }

    .ivu-page-item-active a, .ivu-page-item-active:hover a {
      color: #FFFFFF !important;
    }
  }

  .ivu-page-options {
    margin-left: 0 !important;
    margin-top: 15px !important;
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;

    .ivu-page-options-elevator {
      width: 33px !important;
      height: 100% !important;

      input {
        width: 32px !important;
        height: 50px !important;
        margin: 8px 0 !important;
        display: table-column !important;
        white-space: nowrap;
        line-height: 3.3rem;
        font-weight: unset;
        font-weight: normal;
        text-align: center;
      }
    }
  }

  .ivu-tooltip-popper {
    max-height: 250px !important;

    .ivu-tooltip-inner {
      width: 100%;
      white-space: pre-line !important;

      p {
        white-space: pre-line !important;
      }
    }
  }

}

</style>
